<template>
    <section class="register-view">
        <HeaderComponent :title="'Cadastro'"></HeaderComponent>
        <div class="register-container">
            <div class="personalData" v-if="registerFields.currentPage == 0">
                <div class="etapa">Dados Pessoais (1 de 3)</div>
                <div class="input-container">
                    <span :for="getId(registerFields.personalData[0].display)" :class="{ required: registerFields.personalData[0].required }" v-text="registerFields.personalData[0].display"></span>
                    <div class="select" :id="getId(registerFields.personalData[0].display)" @click="selectList()" v-text="(getPersonalData[getId(registerFields.personalData[0].display)][registerFields.personalData[0].optionDisplay]) || registerFields.personalData[0].placeHolder"></div>
                    <SelectList :hideData="true" :guidancePhrase="'Pesquise o nome da instituição'"></SelectList>
                </div>
                <InputContainer :inputs="registerFields.personalData" @handleInputUpdated="handleInputUpdated()" ref="registerInputs" />
                <div class="button-cont">
                    <ButtonCenter class="button-register" :button="buttonNext" @click="buttonNext.action && buttonNext.action()"></ButtonCenter>
                </div>
            </div>

            <div class="addressData" v-if="registerFields.currentPage == 1">
                <div class="etapa">Endereço (2 de 3)</div>
                <!-- <InputContainer :inputs="registerFields.addressData" ref="addressInputs"/> -->
                <InputsAddress :inputs="registerFields.addressData"></InputsAddress>
                <div class="button-cont">
                    <ButtonCenter class="button-register" :button="buttonNext" @click="buttonNext.action && buttonNext.action()"></ButtonCenter>
                </div>
            </div>

            <div class="dependents" v-if="registerFields.currentPage == 2">
                <div class="etapa">Dependentes (3 de 3)</div>
                <DependentsComponent></DependentsComponent>
                <div class="button-cont">
                    <ButtonCenter class="button-register" :button="buttonFinish" @click="buttonFinish.action && buttonFinish.action()"></ButtonCenter>
                </div>
            </div>
        </div>

        <div class="termVisibility" v-if="readTerms">
            <div class="termContainer" frameborder="0">
                <span @click="termClose()">close</span>
                <iframe :src="retailGeneralParams.URLTERMORESP"></iframe>
            </div>
        </div>

        <SwipeModalComponent v-if="popupOpen" @closeMenu="this.popupOpen = false" class="swipe-modal">
            <div class="content-wrapper">
                <h2>Termos de Uso</h2>

                <h2>Leia os <span @click="handleReadTerms">Termos e Condições</span></h2>

                <div class="buttons" >
                    <button @click="refuseSign">Recusar</button>
                    <button @click="acceptSign" :disabled="!hasReadedTerms">Aceitar</button>
                </div>
            </div>
        </SwipeModalComponent>

        <ModalInfo @toLogin="toLogin()"></ModalInfo>
        <ScreenLoader :isLoading="wait"></ScreenLoader>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import InputContainer from '@/components/inputs/InputContainer.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import DependentsComponent from '@/components/dependents/DependentsComponent.vue'
import SwipeModalComponent from '@/components/bottom-popups/SwipeModalComponent.vue'
import { getClients, checkConsumerByLogin, checkConsumerByCPF, checkConsumerById, registerUser } from '@/components/controllers/RegisterController'
import { correctlyFilled } from '@/components/controllers/ConsumerController'
import { showErrorNotification, findCep, showAlertNotification } from '@/libs/Util.js'
import { mapActions, mapGetters } from 'vuex'
import InputsAddress from '@/components/inputs/InputsAddress.vue'
import SelectList from '@/components/bottom-popups/SelectList.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'

export default {
    name: 'RegisterView',
    components: {
        HeaderComponent,
        InputContainer,
        ButtonCenter,
        DependentsComponent,
        InputsAddress,
        SelectList,
        ModalInfo,
        ScreenLoader,
        SwipeModalComponent
    },
    data () {
        return {
            buttonNext: {
                display: 'Continuar',
                fill: true,
                action: this.nextPage,
                disabled: false
            },
            buttonFinish: {
                display: 'Finalizar',
                fill: true,
                action: this.showTerms,
                disabled: false
            },
            messages: [],
            clients: [],
            error: false,
            wait: false,
            popupOpen: false,
            readTerms: false,
            hasReadedTerms: false
        }
    },
    computed: {
        ...mapGetters(['registerFields', 'getPersonalData', 'getAddressData', 'getDependentsData', 'retailGeneralParams'])
    },
    methods: {
        ...mapActions(['setPersonalData', 'showSelectList', 'closeSelectList', 'showModalInfo', 'clearAllData']),
        showTerms: async function () {
            this.wait = true
            this.error = false
            await this.validateDependents()
            this.wait = false

            if (this.error) {
                this.showMessages()
            } else {
                this.popupOpen = true
            }
        },
        termClose: function () {
            this.readTerms = false
            this.hasReadedTerms = true
        },
        handleReadTerms: function () {
            this.readTerms = true
        },
        refuseSign: function () {
            this.popupOpen = false
            showAlertNotification({ title: '', text: 'Assinatura recusada' })
        },
        acceptSign: async function () {
            this.popupOpen = false
            this.finish()
        },
        nextPage: async function () {
            const current = this.registerFields.currentPage
            if (current === 0) {
                this.wait = true
                const registerInputs = this.$refs.registerInputs
                const inputValues = registerInputs.getValues()
                await this.validateInputs(inputValues)
                if (this.error) {
                    this.showMessages()
                    this.wait = false
                    return false
                }
                this.wait = false
                this.$store.commit('setRegisterPage', 1)
            } else if (current === 1) {
                // valida se os dados de endereços obrigatorios foram informados
                this.wait = true
                this.error = false
                this.registerFields.addressData.forEach((e) => {
                    const valueInput = this.getAddressData[this.getId(e.display)]
                    if (e.required && (typeof valueInput === 'object') && (Object.keys(valueInput).length === 0)) {
                        const message = `O campo ${e.display} deve ser preenchido corretamente.`
                        this.messages.push(message)
                        this.error = true
                    } else if (e.required && (typeof valueInput !== 'object') && (!valueInput || !correctlyFilled(e, valueInput))) {
                        const message = `O campo ${e.display} deve ser preenchido corretamente.`
                        this.messages.push(message)
                        this.error = true
                    }
                })

                // valida o CPF inserido
                const cepData = await findCep(this.getAddressData.cep)
                if (!cepData || cepData.erro) {
                    this.messages.push('O CEP inserido não é válido')
                    this.error = true
                }

                if (this.error) {
                    this.showMessages()
                    this.wait = false
                    return false
                }
                this.wait = false
                this.$store.commit('setRegisterPage', 2)
            }
        },
        validateInputs: async function (inputs) {
            // valida se todos os inputs obrigatorios foram preenchidos
            this.error = false
            if (Object.keys(this.getPersonalData.instituicao).length === 0) {
                this.error = true
                const message = 'O campo Instituição deve ser preenchido.'
                this.messages.push(message)
            }
            inputs.forEach(element => {
                if (element.required && !correctlyFilled(element)) {
                    const message = `O campo ${element.display} deve ser preenchido corretamente.`
                    this.messages.push(message)
                    this.error = true
                } else {
                    this.$store.commit('setPersonalData', { id: element.id, value: element.value })
                }
            })
            if (this.error) return false
            this.validatePassword()
            await this.validateLogin()
            await this.validateCPF()
        },
        validatePassword: function () {
            if (this.getPersonalData.senha && this.getPersonalData.confirmarsenha && (this.getPersonalData.senha !== this.getPersonalData.confirmarsenha)) {
                const message = 'As senhas não correspondem'
                this.messages.push(message)
                this.error = true
            }
        },
        validateCPF: async function () {
            const result = await checkConsumerByCPF()
            if (!result || result.error) {
                this.messages.push(result.message)
                this.error = true
                return false
            }
        },
        validateLogin: async function () {
            const result = await checkConsumerByLogin()
            if (!result || result.error) {
                this.messages.push(result.message)
                this.error = true
            }
        },
        validateDependents: async function () {
            if (this.getDependentsData.length === 0) {
                const message = 'É necessário adicionar pelo menos um dependente'
                this.messages.push(message)
                this.error = true
                return false
            }
            const result = await checkConsumerById()
            if (!result || result.error) {
                this.error = true
                result.message.forEach((e) => { this.messages.push(e) })
                this.showMessages()
            }
        },
        finish: async function () {
            this.wait = true
            this.error = false
            await this.validateDependents()
            if (this.error) {
                this.wait = false
                this.showMessages()
                return false
            }

            const result = await registerUser()

            if (result.error) {
                this.wait = false
                this.showModalInfo({ type: 'error', text: result.message, open: true })
                return false
            }

            this.showModalInfo({
                type: 'success',
                text: 'Novo usuário cadastrado com sucesso.',
                buttons: [
                    {
                        buttonText: 'Ir ao Login',
                        buttonAction: 'toLogin'
                    }],
                open: true
            })
            this.clearAllData()
            this.wait = false
        },
        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase().normalize('NFD').replace(/[^a-zA-Z\s]/g, '')
        },
        selectList: async function () {
            this.wait = true
            this.clients = await getClients()
            this.showSelectList({ title: 'Instituição', options: this.clients, optionDisplay: 'NMFANTCLIE', event: 'setPersonalInstituicaoData' })
            this.wait = false
        },
        showMessages: function () {
            this.messages.reverse().forEach(e => {
                showErrorNotification({
                    title: '',
                    text: e
                })
            })
            this.messages = []
        },
        toLogin: function () {
            this.$router.push('/')
        }
    },
    mounted () {
        this.$store.commit('setRegisterPage', 0)
    }
}
</script>

<style lang="less" scoped>
.register-container {
    position: relative;
    display: block;
    height: 100%;

    .input-container {
        margin-bottom: 15px;
        font-size: 16px;
        display: block;
        width: calc(100%);

        span {
            display: block;
            margin-bottom: 5px;
            &.required:after {
            content: '*';
            color: red;
            margin-left: 5px;
            }
        }
        .select {
            width: calc(100% - 30px);
            padding: 15px;
            font-size: 16px;
            border: 1px solid var(--cardBorder);
            background-color: var(--cardBackground);
            border-radius: 7px;
            margin-top: 10px;
        }
}
    .etapa {
        margin: 30px auto 15px auto;
        font-weight: 600;
        font-size: 18px;
    }

    .button-cont {
        position: fixed;
        bottom: 0;left: 0;
        width: 100%;
        padding-bottom: 40px;
    }
}

.termContainer{
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    span {
        position: relative;
        display: flex;
        margin: 10px 15px auto auto;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-end;
    }
    iframe {
        position: fixed;
        bottom: 0;
        left: 0;
        height: calc(100vh - 50px);
        width: 95vw;
        right: 0;
        margin: auto;
    }
}

.swipe-modal {
    h2 {
        text-align: center;
        margin-top: 30px;

        span {
            color: var(--primaryColor);
        }
    }

    .buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        margin-top: 20px;

        button {
            color: var(--primaryColor);
            padding: 10px 0;
            margin: 20px 15px;
            border: none;
            background-color: transparent;
            font-weight: bold;

            &:disabled {
                color: #B4B4B4;
            }
        }
    }
}

.button-register {
  width: calc(70%)
}

@media (min-width: 769px) {
  .button-register {
    width: 50%;
  }
}

.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.21);
    z-index: 2;
}

</style>
